import React, {FC, useContext, useMemo} from "react";
import {useTranslation} from "react-i18next";
import {LanguageContext} from "../contexts/LanguageContext";
import {ITenantResourceQuery} from "../interfaces/ITenantResourceQuery";
import {ApplicationPacket, ApplicationPacketEnum} from "../API";
import {DateElement, EnumDropdownElement, ITenantColumn, ITenantFormLayout,} from "../components/OnixElements";
import {MakeTenantColumns} from "../helpers/MakeTenantColumns";
import {TitleAndContentLayout} from "../components/TitleAndContentLayout";
import {TenantList} from "../components/TenantList";
import {TenantResource} from "../enums/TenantResource";

export const CompanyApplicationPackets: FC<{ companyId?: number }> = ({
                                                                          companyId,
                                                                      }) => {
    const {t} = useTranslation();
    const {moment, serverDateToLocalDate} = useContext(LanguageContext);

    const query = useMemo<ITenantResourceQuery<ApplicationPacket>>(
        () => ({
            companySettingsId: {
                Equals: companyId,
            },
        }),
        [companyId],
    );

    const columns = useMemo<ITenantColumn<ApplicationPacket>[]>(
        () =>
            MakeTenantColumns<ApplicationPacket>(
                {
                    packet: {
                        render: (item) => <span>{ApplicationPacketEnum[item.packet]}</span>,
                    },
                    from: {},
                    to: {},
                },
                t,
            ),
        [t],
    );

    const applicationPacketsForm = useMemo<ITenantFormLayout<ApplicationPacket>>(
        () => ({
            packet: {
                type: new EnumDropdownElement({
                    enumData: ApplicationPacketEnum,
                }),
            },
            from: {
                type: new DateElement({}),
            },
            to: {
                type: new DateElement({}),
            },
        }),
        [],
    );
    return (
        <TitleAndContentLayout title={"application_packets"} isSubtitle noPadding>
            <TenantList<ApplicationPacket, ApplicationPacket, ApplicationPacket>
                resource={TenantResource.ApplicationPackets}
                form={applicationPacketsForm}
                query={query}
                queryIsRequired
                addingTitle={"adding_packet"}
                editingTitle={"editing_packet"}
                baseDto={{companySettingsId: companyId}}
                columns={columns}
            />
        </TitleAndContentLayout>
    );
};
